"use strict";

var cx = require("classnames");
var _ = require("underscore");
var textFormatter = require("app/util/formatter/text");
var Reflux = require("reflux");
var MetricType = require("../Metric/metric-type.jsx");
var ActivityTypeStore = require("app/screens/Activity/stores/activity-type-store");
var ActivityTypeActions = require("app/screens/Activity/actions/activity-type-actions");
var Button = require("app/shared/components/Button/button");
var Tooltip = require("app/shared/components/Tooltip/tooltip");

var ActivityTypeFilter = React.createClass({
  mixins: [Reflux.ListenerMixin],
  firstUpdate: true,
  getInitialState: function () {
    return ActivityTypeStore.state;
  },
  componentDidMount: function() {
    this.listenTo(ActivityTypeStore, this.updateTypes);
    ActivityTypeActions.getActivityTypes(this.props.filters.metric_ids);
  },
  componentDidUpdate: function() {
    $(ReactDOM.findDOMNode(this)).find("[data-toggle='tooltip']").tooltip();
  },
  updateTypes: function(newState) {
    this.props.setFilter("metric_ids", _.pluck(this.getSelectedTypes(newState.types), "id"), this.firstUpdate);
    this.props.setFilter("metric_names", _.pluck(this.getSelectedTypes(newState.types), "name"), this.firstUpdate);
    this.props.setFilter("offset", 0, true);
    this.firstUpdate = false;
    this.setState(newState);
  },
  toggleOption: function(type, event) {
    event.preventDefault();
    ActivityTypeActions.selectType(type.id, !type.selected);
  },
  getSelectedTypes: function(types) {
    return _.where(types, {selected: true});
  },
  filterTooltip: function(type) {
    const typeName = textFormatter.capitalizeFirstLetter(type.name);
    return `Filtrar por ${typeName}`;
  },
  render: function() {
    var buttons = this.state.types.map(function(type, i) {
      var className = cx({ "selected": type.selected }, "btn-icon");
      var imageTag = (type.selected ? "-selected" : "");

      return (
        <Button onClick={this.toggleOption.bind(this, type)} key={i} type="filter" className={className}>
          <Tooltip title={this.filterTooltip(type)} container="body">
            <img src={MetricType.getImageUrl(type.metric_type.name, imageTag)} data-type-id={type.id} />
          </Tooltip>
        </Button>
      );
    }.bind(this));
    return (
      <div className="activityType-filter d-f jc-sb" style={{"width": 250}}>
        {buttons}
      </div>
    );
  }
});

module.exports = ActivityTypeFilter;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activity-type-filter.jsx